import { CommonModule } from '@angular/common';
import { ModuleWithProviders, NgModule } from '@angular/core';

import { AppConfigurationResolver, AppConfigurationService } from './shared';

@NgModule({
    imports: [CommonModule],
    exports: [],
    declarations: [],
    providers: [],
})
export class AppConfigurationModule {
    // forRoot is used to define services that must be singleton even for Lazy loaded modules
    static forRoot(): ModuleWithProviders<AppConfigurationModule> {
        return {
            ngModule: AppConfigurationModule,
            providers: [AppConfigurationService, AppConfigurationResolver],
        };
    }
}
